import "../../../css/product-cards.scss";
import "../../../css/ribbon-labels.scss";
import { ModalPopup } from "../../Components/ModalPopup";
import { AutoFormatNumber } from '../../Helpers/FormatNumber';
import { Slugify } from '../../Helpers/index';
import { DataLayerModelFactory } from "../../Services/DataLayer/DataLayerEvents";
import { AjaxPost } from '../../Services/index';
import AddToCartVM from "./Components/AddToCart";
import { KnockoutValidationSettings } from "../../Globals/KnockoutValidationSettings";

export class CategoryVM {

    public AlertModal: ModalPopup = new ModalPopup();    

    private ProductLink = (el) => {
        return "/products/details/" + el.dataset.id + "/" + Slugify(el.dataset.heading) + "/";
    }
    private AddToCart = AddToCartVM.AddToCart;

    private ApprovalType = new AddToCartVM().ApprovalType;
    private SelectedApprover = new AddToCartVM().SelectedApprover;
    private SelectApprover = new AddToCartVM().SelectApprover;
    private ContractPricingLevels = new AddToCartVM().ContractPricingLevels
    private AddressBook = new AddToCartVM().AddressBook;
    private Comment = new AddToCartVM().RestrictionComment;
    private CustName = new AddToCartVM().CustName;
    private CustPhone = new AddToCartVM().CustPhone;
    private CustEmail = new AddToCartVM().CustEmail;
    private AltItemsHtml = AddToCartVM.AltItemsHtml;
    private RestrictionItems = new AddToCartVM().RestrictionItems;
    private ShowRetrictionModal = new AddToCartVM().ShowRetrictionModal;

    private ArrayToUpdate = (itemID?: string) => {
        return ko.observableArray([]); //dummy array so it doesn't complain
    }
    
    private FormatNumber = AutoFormatNumber;
    private AddToContractFunction = function (ItemID) {

        return new Promise(function (resolve, reject) {
            return new AjaxPost({
                endpoint: '/ShoppingCart/AddItemToContract',
                payload: JSON.stringify({ ItemID: ItemID })
            })
        });
    }

    constructor() {        
        ko.validation.init(KnockoutValidationSettings, true);
       
        let self = this;

        //events: ref. jquery on click events(add to contract)
        AddToCartVM.EventListeners(self);
       
       
        // Event listeners for quick action buttons
        $(() => {
            $('.btn-quickadd').mouseover(function () {
                $(this).removeClass('btn-dark');
                $(this).addClass('btn-success');
            }).mouseout(function () {
                $(this).removeClass('btn-success');
                $(this).addClass('btn-dark');
            })
            $('.btn-options').mouseover(function () {
                $(this).removeClass('btn-dark');
                $(this).addClass('btn-primary');
            }).mouseout(function () {
                $(this).removeClass('btn-primary');
                $(this).addClass('btn-dark');
            });


            $('.btn-quickadd, .btn-options').hover(function (event) {
                $(this).css({ 'color': event.type === 'mouseover' ? '#fff' : '#fff' });
            });
        });

        // Analytics data layer implementation
        $(() => {

            if (window.location.pathname === "/") {
                return;
            }

            let Model = window.Model;

            let productsModel: Array<any> = Model.itemGroupModel || [];

            let dataLayerItems = productsModel.filter((item) => {
                return item.SingleItemID;
            });

            let products = [];

            if (dataLayerItems.length) {
                products = dataLayerItems.map(function (obj, index) {
                    return {
                        brand: obj.VendName,
                        id: obj.SingleItemID || obj.DisplayItemID,
                        name: obj.Heading,
                        price: obj.LowestPrice,
                        variant: obj.DisplayUMQty,
                        position: index
                    }
                })
            }

            let analytics = new DataLayerModelFactory().impressions(products, "productView", "Category Group Product View");

            if (analytics.ecommerce.impressions.length) {
                window.dataLayer.push(analytics);
            }

            $('.fa-cart-plus').parent().on('click', function () {
                let itemID = $(this).attr('data-itemid');

                let product = products.find(function (singleItem) {
                    return singleItem.id === itemID;
                });

                product.quantity = 1;
                console.debug("dataLayer product:", product);

                window.dataLayer.push(new DataLayerModelFactory().addToCart(product));
            });
        })
    }
}